import React, { FC, ReactNode } from 'react';
import useClassNames from '@loomstateorg/shared-frontend/hooks/useClassNames';

export type WrapperBackground = 'white' | 'site';

export type WrapperProps = {
  children: ReactNode;
  background?: WrapperBackground;
  className?: string;
  clearDefaultStyles?: boolean;
};

const Wrapper: FC<WrapperProps> = ({ children, background, className, clearDefaultStyles }) => {
  const outerClassName = useClassNames([background ? `bg-${background}` : undefined]);

  const wrapperClassName = useClassNames(
    clearDefaultStyles ? [className] : [className, 'px-16 md:px-24 lg:px-20 xl:px-48'],
  );

  return (
    <div className={outerClassName}>
      <div className={wrapperClassName}>{children}</div>
    </div>
  );
};

export default Wrapper;
